import * as React from "react";
import { CategoryCard } from "../../types/CategoriesCard";
import getCategoriesCard from "../../requests/getCategoriesCard";
import Category from "./Category/Category";
import "./Component.css";
import Collapse from "@material-ui/core/Collapse";
import Arrow from "@material-ui/icons/KeyboardArrowDown";
import cn from "classnames";

const MAX_VISIBLE_CATEGORIES = 2;

interface Props {
	disable?: boolean;
	userId?: number;
}

const Component: React.FC<Props> = (props) => {
	const [categories, setCategories] = React.useState<CategoryCard[]>([]);
	const [loading, setLoading] = React.useState(false);
	const [categoryVisible, setCategoriesVisible] = React.useState(false);

	React.useEffect(() => {
		let isCancelled = false;

		setLoading(true);

		getCategoriesCard(props.userId).then((data) => {
			if (!isCancelled) {
				setCategories(data);
				setLoading(false);
			}
		});

		return () => {
			isCancelled = true;
		};
	}, [props.userId]);

	const visibleCategories = React.useMemo(
		() => categories.slice(0, MAX_VISIBLE_CATEGORIES),
		[categories]
	);
	const hiddenCategories = React.useMemo(
		() => categories.slice(MAX_VISIBLE_CATEGORIES),
		[categories]
	);
	const hiddenCategoriesPercent = React.useMemo(() => {
		let total = 0;

		hiddenCategories.forEach((category) => (total += category.percent));

		return total;
	}, [hiddenCategories]);

	const onClick = (id: number) => {
		if (!props.disable) {
			window.location.href = `/books#/all/${id}`;
		}
	};

	if (visibleCategories.length === 0) {
		return (
			<div className="categoriesCard">
				<div className="categoriesCard-empty">
					Здесь будет отображаться статистика по вашей библиотеке.
				</div>
			</div>
		);
	}

	return (
		visibleCategories.length > 0 && (
			<div className="categoriesCard">
				{visibleCategories.map((category) => {
					return <Category category={category} onClick={onClick} />;
				})}

				{hiddenCategories.length > 0 && (
					<>
						<div
							className={cn(
								"categoriesCard-category categoriesCard-category_more",
								{
									"categoriesCard-category_more_open": categoryVisible,
								}
							)}
							onClick={() => setCategoriesVisible(!categoryVisible)}
						>
							<div className="categoriesCard-category__name">
								<Arrow />
								Остальные категории
							</div>

							<div className="categoriesCard-category__count">
								{hiddenCategoriesPercent}%
							</div>
						</div>

						<Collapse in={categoryVisible}>
							{hiddenCategories.map((category, index) => {
								return (
									<Category category={category} key={index} onClick={onClick} />
								);
							})}
						</Collapse>
					</>
				)}
			</div>
		)
	);
};

export default Component;
